"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3029],{

/***/ 83029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _BasePopup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73495);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3245);
/* harmony import */ var enums_routeType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33973);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62044);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);






var BuySubscriptionPopup = function(param) {
    var onClose = param.onClose;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Popups */ .l.Popups).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BasePopup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        showCloseIcon: false,
        classes: [
            "subscription"
        ],
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: t("activate_subscription_title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("activate_subcription_content")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "buttons",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/".concat(enums_routeType__WEBPACK_IMPORTED_MODULE_3__/* .RouteType.ChoosePlan */ .Y.ChoosePlan),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "btn",
                        children: t("activate_subscription_button")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BuySubscriptionPopup);


/***/ })

}]);